module.exports = __webpack_public_path__ + "static/sand_texture-f8a6854949fb11a99dfe6a5daad6a9a7.jpg";